export default {"src":"/_next/static/media/yellowDotactive.12814fef.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};